export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5258.9fac7202.jpg";